import * as actions from './actions'

const attentionServicesModule = {
    namespaced: true,
    actions,
}

export default attentionServicesModule
